export interface IA11yTargetList {
	list: HTMLElement[];
	first: HTMLElement;
	last: HTMLElement;
}

export enum EA11yId {
	callMenuPREFIX,
	callsInitPoint,
	callsPREFIX,
	callsPREFIXsearchDial,
	callsPREFIXhistory,
	chatActivityBackArrow,
	chatActivityListbox,
	chatConversationListbox,
	chatHeaderToolbar,
	chatHeaderBackArrow,
	chatInfoInitPoint,
	chatInitPoint,
	chatMessageArea,
	chatMessageInputField,
	chatPREFIX,
	chatPREFIXconversation,
	chatPREFIXactivity,
	chatPREFIXEmojiSelector,
	chatPREFIXfooterButton,
	chatPREFIXheaderButton,
	chatPREFIXinfoUser,
	chatPREFIXinfoGroup,
	chatPREFIXmessageMenu,
	chatPREFIXmediaBrowser,
	chatPREFIXpreview,
	chatPREFIXsearch,
	chatPREFIXautocompleteContact,
	contactsInitPoint,
	contextMenuPREFIX,
	contextSubMenuPREFIX,
	customAppInitPoint,
	loginFieldPREFIX,
	dialogCalendarInitPoint,
	dialogForwardMessageInitPoint,
	dialogNewGroupInitPoint,
	dialogPREFIXnewGroup,
	dialogPREFIXuploadGroupImage,
	headerSmToggleButton,
	informationPREFIX,
	informationAboutPREFIX,
	informationLicensesPREFIX,
	journalInfoInitPoint,
	journalInitPoint,
	journalPREFIXcontactCard,
	journalPREFIXtable,
	journalMenuPREFIX,
	meMenuPREFIX,
	settingsPREFIX,
	searchResultsMenuPREFIX,
	smPREFIXselectorButton,
	avCallContextMenuPREFIX,
	searchResultsDialMenuPREFIX,
	sharedButtonPREFIX
}

/**
 * Contains helper functions for a11y (accessibility)
 */
export default class A11yHelper {
	private static instance: A11yHelper | null = null;
	private a11yNamesMap: Map<EA11yId, string>;
	// this is an experimental logic, used only in Settings.tsx (main application)
	// it could work everywhere, with the great benefit of reducing the listeners
	// and removing the hard-coded ids (we can just use React hook useId to generate them)
	private _lastTabItemId?: string;

	/**
	 * Constructs a11yHelper.
	 * Method is private as we follow the Singleton Approach using getInstance
	 */
	private constructor() {
		this.a11yNamesMap = new Map<EA11yId, string>();

		// CHAT  ------------------------------------------------------------
		this.a11yNamesMap.set(EA11yId.chatActivityBackArrow, "a11y-chat-back-arrow");
		this.a11yNamesMap.set(EA11yId.chatActivityListbox, "a11y-chat-listbox");
		this.a11yNamesMap.set(EA11yId.chatConversationListbox, "a11y-chat-conversation-listbox");
		this.a11yNamesMap.set(EA11yId.chatHeaderToolbar, "a11y-chat-header-toolbar");
		this.a11yNamesMap.set(EA11yId.chatHeaderBackArrow, "a11y-chat-header-back-arrow");
		this.a11yNamesMap.set(EA11yId.chatInfoInitPoint, "a11y-chat-info-initial");
		this.a11yNamesMap.set(EA11yId.chatInitPoint, "a11y-chat-initial-searchfield");
		this.a11yNamesMap.set(EA11yId.chatMessageArea, "a11y-chat-message-area");
		this.a11yNamesMap.set(EA11yId.chatMessageInputField, "a11y-chat-message-input-textfield");
		this.a11yNamesMap.set(EA11yId.chatPREFIX, "a11y-chat-");
		this.a11yNamesMap.set(EA11yId.chatPREFIXactivity, "a11y-chat-activity-");
		this.a11yNamesMap.set(EA11yId.chatPREFIXconversation, "a11y-chat-cc-");
		this.a11yNamesMap.set(EA11yId.chatPREFIXEmojiSelector, "a11y-chat-emoji-");
		this.a11yNamesMap.set(EA11yId.chatPREFIXfooterButton, "a11y-chat-footer-button-");
		this.a11yNamesMap.set(EA11yId.chatPREFIXheaderButton, "a11y-chat-header-tb-button-");
		this.a11yNamesMap.set(EA11yId.chatPREFIXinfoUser, "a11y-chat-info-user-");
		this.a11yNamesMap.set(EA11yId.chatPREFIXinfoGroup, "a11y-chat-info-group-");
		this.a11yNamesMap.set(EA11yId.chatPREFIXmediaBrowser, "a11y-chat-media-browser- ");
		this.a11yNamesMap.set(EA11yId.chatPREFIXpreview, "a11y-chat-preview-");
		this.a11yNamesMap.set(EA11yId.chatPREFIXsearch, "a11y-chat-search-");
		this.a11yNamesMap.set(EA11yId.chatPREFIXautocompleteContact, "a11y-chat-autocomplete-contact-");

		// LOGIN ---------------------------------------------------------------------
		this.a11yNamesMap.set(EA11yId.loginFieldPREFIX, "a11y-login-");

		// CALLS  ------------------------------------------------------------
		this.a11yNamesMap.set(EA11yId.callsPREFIX, "a11y-calls-");
		this.a11yNamesMap.set(EA11yId.callsInitPoint, "a11y-calls-initial-searchfield");
		this.a11yNamesMap.set(EA11yId.callsPREFIXsearchDial, "a11y-calls-search-dial-");
		this.a11yNamesMap.set(EA11yId.callsPREFIXhistory, "a11y-calls-history-");

		// CONTACTS  ------------------------------------------------------------
		this.a11yNamesMap.set(EA11yId.contactsInitPoint, "a11y-contacts-info-initial");

		// CUSTOM APPS  ------------------------------------------------------------
		this.a11yNamesMap.set(EA11yId.customAppInitPoint, "a11y-customapp-area-tab");

		// DIALOGS  ------------------------------------------------------------
		this.a11yNamesMap.set(EA11yId.dialogCalendarInitPoint, "a11y-dialog-calendar");
		this.a11yNamesMap.set(EA11yId.dialogForwardMessageInitPoint, "a11y-dialog-forward-message");
		this.a11yNamesMap.set(EA11yId.dialogNewGroupInitPoint, "a11y-dialog-new-group-headline");
		this.a11yNamesMap.set(EA11yId.dialogPREFIXnewGroup, "a11y-dialog-new-group-");
		this.a11yNamesMap.set(EA11yId.dialogPREFIXuploadGroupImage, "a11y-dialog-upload-group-image");

		// JOURNAL  ------------------------------------------------------------
		this.a11yNamesMap.set(EA11yId.journalInitPoint, "a11y-journal-initial-searchfield");
		this.a11yNamesMap.set(EA11yId.journalInfoInitPoint, "a11y-journal-info-initial");
		this.a11yNamesMap.set(EA11yId.journalPREFIXtable, "a11y-journal-table-");
		this.a11yNamesMap.set(EA11yId.journalPREFIXcontactCard, "a11y-journal-contact-card-");

		// HEADER  ------------------------------------------------------------
		this.a11yNamesMap.set(EA11yId.headerSmToggleButton, "a11y-header-button-toggle-sm");

		// INFORMATION  ------------------------------------------------------------
		this.a11yNamesMap.set(EA11yId.informationPREFIX, "a11y-information-");
		this.a11yNamesMap.set(EA11yId.informationAboutPREFIX, "a11y-information-about-");
		this.a11yNamesMap.set(EA11yId.informationLicensesPREFIX, "a11y-information-licenses-");

		// SIDEMENU  ------------------------------------------------------------
		this.a11yNamesMap.set(EA11yId.smPREFIXselectorButton, "a11y-sm-button-selector-");

		// SETTINGS  ------------------------------------------------------------
		this.a11yNamesMap.set(EA11yId.settingsPREFIX, "a11y-settings-");

		// CONTEXT MENUS  ------------------------------------------------------------
		this.a11yNamesMap.set(EA11yId.contextMenuPREFIX, "a11y-context-menu-");
		this.a11yNamesMap.set(EA11yId.contextSubMenuPREFIX, "a11y-context-sub-menu-");

		this.a11yNamesMap.set(EA11yId.meMenuPREFIX, "a11y-me-menu-");
		this.a11yNamesMap.set(EA11yId.journalMenuPREFIX, "a11y-journal-menu-");
		this.a11yNamesMap.set(EA11yId.callMenuPREFIX, "a11y-call-menu-");
		this.a11yNamesMap.set(EA11yId.searchResultsMenuPREFIX, "a11y-search-results-menu-");
		this.a11yNamesMap.set(EA11yId.chatPREFIXmessageMenu, "a11y-chat-message-menu-");
		this.a11yNamesMap.set(EA11yId.avCallContextMenuPREFIX, "a11y-av-call-context-menu-");
		this.a11yNamesMap.set(EA11yId.searchResultsDialMenuPREFIX, "a11y-search-results-dial-menu-");
		this.a11yNamesMap.set(EA11yId.sharedButtonPREFIX, "a11y-shared-button");
	}

	/**
	 * Gets instance of a11Helper to use as singleton.
	 *
	 * @returns - an instance of this class.
	 */
	public static getInstance(): A11yHelper {
		if (!this.instance)
			this.instance = new A11yHelper();

		return this.instance;
	}

	/**
	 * Get the last stored tab item id
	 * @returns - the id or undefined
	 */
	public get lastTabItemId(): string | undefined {
		return this._lastTabItemId;
	}

	/**
	 * Set the last stored tab item id
	 */
	public set lastTabItemId(id: string | undefined) {
		this._lastTabItemId = id;
	}

	/**
	 * move focus to another element by arrow key
	 *
	 * @param event - keyboard event to trigger focus shift
	 * @param listOfTargets - IA11yTargetList of targets with first and last target in a component with multiple elements
	 * @param vertical - set true if the direction in which the focus should move is vertical
	 */
	public moveFocusThroughTargetListByKey(
		event: React.KeyboardEvent,
		listOfTargets: IA11yTargetList,
		vertical?: true): void {
		//
		if (!event || listOfTargets.list.length < 1)
			return;

		const targetFromEvent = event.currentTarget as HTMLElement;
		const targetList = listOfTargets.list;
		const firstTarget = listOfTargets.first;
		const lastTarget = listOfTargets.last;
		let flag = false;

		const moveFocusToTab = (target: HTMLElement) => {
			target.focus();
		};

		const moveFocusToPreviousTab = (target: HTMLElement) => {
			let index;
			if (target === firstTarget)
				moveFocusToTab(lastTarget);
			else {
				index = targetList.indexOf(target);
				moveFocusToTab(targetList[index - 1]);
			}
		};

		const moveFocusToNextTab = (target: HTMLElement) => {
			let index;
			if (target === lastTarget)
				moveFocusToTab(firstTarget);
			else {
				index = targetList.indexOf(target);
				moveFocusToTab(targetList[index + 1]);
			}
		};
		switch (event.key) {
			case "ArrowUp":
				if (vertical) {
					moveFocusToPreviousTab(targetFromEvent);
					flag = true;
				}
				break;
			case "ArrowLeft":
				moveFocusToPreviousTab(targetFromEvent);
				flag = true;
				break;
			case "ArrowDown":
				if (vertical) {
					moveFocusToNextTab(targetFromEvent);
					flag = true;
				}
				break;
			case "ArrowRight":
				moveFocusToNextTab(targetFromEvent);
				flag = true;
				break;
			case "Home":
				moveFocusToTab(firstTarget);
				flag = true;
				break;
			case "End":
				moveFocusToTab(lastTarget);
				flag = true;
				break;
			default:
				break;
		}

		if (flag) {
			event.stopPropagation();
			event.preventDefault();
		}
	}

	/**
	 * move focus to another a11y element
	 *
	 * @param a11yIdToFind - a11y id of the element to which the focus should be moved
	 * @param sender - a11y ID of the sender element from which the focus comes. Only required for TAB. Do not use for SHIFT TAB. (optional)
	 * @param a11yLabel - text for the aria label for and during movement (screenreader)
	 */
	public shiftFocusToElement = (a11yIdToFind: string, sender?: string | null, a11yLabel?: string | null): void => {
		const goToElement = document.getElementById(a11yIdToFind);

		if (goToElement) {
			if (sender)
				goToElement.setAttribute("data-a11y-goback", sender);

			if (a11yLabel)
				goToElement.setAttribute("aria-label", a11yLabel);

			goToElement.focus();
		}
	};

	/**
	 * Move the focus from this element back to the sender if the sender ID is stored in the attributes of this element. Used for the SHIFT-TAB action.
	 *
	 * @param a11yIdElementItself - a11y ID of the element itself where the function is called, so that we can search for a stored sender in the HTML attributes
	 */
	public shiftFocusBackFromElement = (a11yIdElementItself: string): void => {
		const a11yElement = document.getElementById(a11yIdElementItself);
		const dataA11yGoBackId = a11yElement?.getAttribute("data-a11y-goback");

		if (dataA11yGoBackId) {
			const goBackToElement = document.getElementById(dataA11yGoBackId);
			if (goBackToElement) {
				goBackToElement.setAttribute("tabindex", "1");
				goBackToElement.focus();
				goBackToElement.setAttribute("tabindex", "0");
			}
		}
	};

	/**
	 * Function to organize frequently used a11y jump points. Returns an id (= string).
	 *
	 * @param a11yJumpPoint - name of the jump point
	 * @returns the id of the element
	 */
	public getId(a11yJumpPoint: EA11yId): string {
		return this.a11yNamesMap.get(a11yJumpPoint) || "";
	}
}
